import React from 'react'
import moment from 'moment-timezone'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
// import { createStore, applyMiddleware } from 'redux'
// import { composeWithDevTools } from 'redux-devtools-extension'
import { Provider } from 'react-redux'
// import * as serviceWorker from './serviceWorker'
// import rootReducer from './reducers'
// import thunk from 'redux-thunk'
import 'moment/locale/it'

import { store } from './store'

import './styles/app.scss'

import Layout from './components/Layout'
import Login from './components/Login'
import AuthorizedLayout from './components/AuthorizedLayout'
import Dashboard from './components/Dashboard'
import Detections from './components/Detections'
import Inspections from './components/Inspections'
import LotDetails from './components/Detections/LotDetails'
import Settings from './components/Settings'
import Restores from './components/Restores'

moment.tz.setDefault('Europe/London')

// store.subscribe(() => console.log('store', store.getState()));

const root = ReactDOM.createRoot(document.getElementById('root'))
// const location = window.location.pathname
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path='*' element={<Login />} />
          <Route element={<AuthorizedLayout />}>
            <Route exact path='/dashboard' element={<Dashboard />} />
            <Route exact path='/detections' element={<Detections />} />
            <Route
              exact
              path='/detections/:id/:name'
              element={<LotDetails />}
            />
            <Route exact path='/inspections' element={<Inspections />} />
            <Route exact path='/restores' element={<Restores />} />
            <Route exact path='/settings' element={<Settings />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister()
